import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const TextImage2dSlide = Scrivito.provideObjClass("TextImage2dSlide", {
  attributes: {
    backgroundImage: ["reference", { only: ["Image"] }],
    body: "html",
    imageBottom: ["reference", { only: ["Image"] }],
    imageLeft: ["reference", { only: ["Image"] }],
    sortKey: "integer",
    subtitle: "string",
    targetLink: "link",
    ...defaultPageAttributes,
    ...metadataAttributes,
  },
});

export default TextImage2dSlide;
